import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from 'app/store/model/authUser/selectors/getAuthUser';

export const isShowChat = (
    state: IApplicationState
): boolean => {
    return getAuthUser(state).allowKanbanChat ;
};
